
import GTMPageViewingMixin from '@homeserve/vue-components-plugin/src/mixins/GTMPageViewingMixin';
import { getPartnerDetailsResult } from '@homeserve/od-typings/api';
import { Component, Mixins } from 'vue-property-decorator';
import { Getter } from 'vuex-class';

@Component({})
export default class LegalNotices extends Mixins(GTMPageViewingMixin) {
  @Getter('partner')
  private partner!: getPartnerDetailsResult;

  get baseUrl() {
    return this.partner.websiteUrl;
  }

  get supportEmail() {
    return this.partner.supportEmail;
  }

  get supportPhone() {
    return this.partner.supportPhone;
  }
}
